/** Shared external links used across the app. */

/** "1 min survey" Google Form used in the footer, nav menu, and profile. */
export const SURVEY_URL =
  'https://docs.google.com/forms/d/1J8XH1ziX9JfU8kV6hxWjXLn7OO3J5I9nQIqFxelYVpM';

/** Support contact email. */
export const CONTACT_EMAIL = 'hello@pineapplemusiclab.com';

/** Google Play listing for the Android app (package com.pineapplemusiclab.piano). */
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.pineapplemusiclab.piano';
